import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
import { RoutesConfig } from "./RoutesConfig";
import Auth from '../Auth';
import MainLayout from '../Layout/MainLayout';

const ProtectedRoute = ({ element }) => {
    const { isAuthenticated } = useUser();

    if (!isAuthenticated) return <Navigate to="/auth" replace />;

    return <MainLayout>{element}</MainLayout>;
};

const AppRoutes = () => {
    const { isAuthenticated } = useUser();
    return (
        <Routes>
            {/* The authorization page is only available before logging in */}
            {!isAuthenticated && <Route path="/auth" element={<Auth />} />}

            {/* The main routes with protection  */}
            {RoutesConfig.map(({ path, element }) => (
                <Route
                    key={path}
                    path={path}
                    element={<ProtectedRoute element={element} />}
                />
            ))}

            {/* Smart redirect from / by role*/}
            {/* <Route
                path="/"
                element={
                    <ProtectedRoute
                        element={<RoleRedirect />}
                        roles={["user", "admin", "master"]}
                    />
                }
            /> */}

            {/* 404 fallback */}
            <Route path="*" element={<Navigate to="/home" replace />} />
        </Routes>
    );
};

export default AppRoutes;